import { useQuery } from '@tanstack/react-query';
import { reservationSpanPaymentLinkOptions } from '../../constants/reservationSpanPaymentLinks';
/** What the signed payment link leads to; `reservationSpanPaymentLinkError` holds the backend's refusal. */
export function useReservationSpanPaymentLink(filter) {
    const { data, isLoading, error, refetch } = useQuery(reservationSpanPaymentLinkOptions.get(filter));
    return {
        reservationSpanPaymentLink: data,
        loadingReservationSpanPaymentLink: isLoading,
        reservationSpanPaymentLinkError: error ?? undefined,
        refetchReservationSpanPaymentLink: refetch,
    };
}
